import styled from 'styled-components/macro';

import { distances } from '../../styles/constants';

const ButtonGroup = styled.div`
    > a,
    > button,
    > div,
    > input {
        margin-right: ${distances.tiny};
        margin-bottom: 8px;
        &::last-child {
            margin-right: 0;
        }
    }
`;

export default ButtonGroup;
